import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  ModalController,
  IonIcon,
  IonButton,
  IonText,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { informationCircleOutline, close } from 'ionicons/icons';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'lib-self-check-help',
  templateUrl: './self-check-help.component.html',
  styleUrls: ['./self-check-help.component.scss'],
  imports: [IonIcon, IonButton, IonText],
})
export class SelfCheckHelpComponent {
  private readonly modalController: ModalController = inject(ModalController);

  constructor() {
    addIcons({ informationCircleOutline, close });
  }

  /**
   * Dismiss the modal.
   */
  public async dismiss(): Promise<void> {
    await this.modalController.dismiss();
  }
}
